
  interface IStoreActivityForm {
    [key: string]: any;
  }
  
  import {
    Watch,
    Inject,
    Component,
    Vue,
    PropSync,
    Prop,
    Ref,
    InjectReactive,
    Emit,
  } from "vue-property-decorator";
  import UploadImg from "@/components/uploadImg.vue";
  import { clientActivityDict, activityClientDict, saveOrUpdateClientActivity } from "@/api/clientActivity";

  import { cloneDeep } from "lodash";
  import dayjs from "dayjs";

  @Component({ name: 'clientActivity-components-add',
    components: {
      UploadImg,
    },
  })
  export default class ClientActivityForm extends Vue {
    @InjectReactive() activityTypeList: Array<any>;
    @PropSync("formVisible") visible: boolean;
    @Ref("form") formRef: VForm;
    @InjectReactive() activityDetail: any;
    @Prop() private operateRecord: any;
    @Prop() private locationOptions: any;
    @Prop() private clientOptions: any;


    hzOptions = [
        {
            value: 1,
            label: "1次/日"
        },
        {
            value: 2,
            label: "每次弹出"
        },
    ]
  
    form = {
      id: "",
      activityName: "",
      ejectPosition: undefined,
      applicationProgramList: [],
      startTime: "",
      endTime: "",
      ejectFrequency: 1,
      status: 1,
      activityTipsImgList: [{imgUrl: [], linkUrl: ""},{imgUrl: [], linkUrl: ""}],
    };

    get endTimeOptions(){
      const vm = this;
      return {
        disabledDate(time) {
          if (!vm.form.startTime) {
            return false;
          }
          return dayjs(time).isBefore(dayjs(vm.form.startTime));
        }
      }
    } 

    get startTimeOptions(){
      const vm = this;
      return {
        disabledDate(time) {
          if (!vm.form.endTime) {
            return false;
          }
          return dayjs(time).isAfter(dayjs(vm.form.endTime));
        }
      }
    } 
  
    saveLoading = false;
  
    status = 0;
  
    formRules = {
      activityName: { required: true, message: "请输入活动名称" },
      ejectPosition: { required: true, message: "请选择弹出位置" },
      applicationProgramList: { required: true, type: "array", message: "请选择应用" },
      startTime: { required: true, message: "请选择开始时间" },
      ejectFrequency: { required: true, message: "请选择弹出频率" },
      status: { required: true, message: "请选择状态" },
      activityTipsImgList: { required: true, type: "array", message: "请上传图片，最多可上传9张照片" },
      imgUrl: { required: true, type: "array", message: "请上传图片" },
      linkUrl: { required: true, message: "请输入链接地址" },
    };
  
    showTransfer = false;
    storeKeyValueMap = {};
  
    getDetailLoading = false;

    get getDialogTitle() {
      return `${this.form.id ? '编辑' : '新增'}`;
    }

    get useClientOptions() {
      // 90001-首页，90002-门店管理页，90003-数据看板页
      const map = {
        90001: [91001, 91002, 91005, 91006, 91003, 91004],
        90002: [91002, 91002, 91005, 91006],
        90003: [91002, 91005, 91006, 91003],
      }
      const dicList = map[this.form.ejectPosition];

      if (!this.form.ejectPosition) return this.clientOptions;

      return this.clientOptions.filter((el) => {
        return dicList.includes(el.value);
      })
    }

    mounted() {
      // this.getClientActivityDict();
      // this.getActivityClientDict();
    }

    // getClientActivityDict() {
    //   clientActivityDict().then((res) => {
    //     this.locationOptions = res.data?.map((el) => {
    //       return {
    //         value: el.id,
    //         label: el.dictValue,
    //       }
    //     });
    //   });
    // }

    // getActivityClientDict() {
    //   activityClientDict().then((res) => {
    //     this.clientOptions = res.data?.map((el) => {
    //       return {
    //         value: el.id,
    //         label: el.dictValue,
    //       }
    //     });
    //   });
    // }

    ejectPositionChange($event){
      // 选择位置之后把applicationProgramList清空
      if (!$event) return;
      this.form.applicationProgramList = [];
    }

    addRow() {
      if (this.form.activityTipsImgList?.length >= 9) return;
      this.form.activityTipsImgList?.push({ imgUrl: [], linkUrl: "" })
    }

    toPre(index: number) {
        const activityTipsImgList = cloneDeep(this.form.activityTipsImgList);
        [this.form.activityTipsImgList[index], this.form.activityTipsImgList[index - 1]] = [activityTipsImgList[index - 1], activityTipsImgList[index]];
        this.form = cloneDeep(this.form);
    }
    toNext(index: number) {
        const activityTipsImgList = cloneDeep(this.form.activityTipsImgList);
        [this.form.activityTipsImgList[index + 1], this.form.activityTipsImgList[index]] = [activityTipsImgList[index], activityTipsImgList[index + 1]];
        this.form = cloneDeep(this.form);
    }

    toDel(index: number) {
      this.form.activityTipsImgList.splice(index, 1);
    }
  
    handleClose(): void {
      this.cancel();
    }
  
    cancel() {
      // this.formRef?.resetFields(); 这个用了会在某些时候报错
      this.form = {
        id: "",
        activityName: "",
        ejectPosition: undefined,
        applicationProgramList: [],
        startTime: "",
        endTime: "",
        ejectFrequency: 1,
        status: 1,
        activityTipsImgList: [{imgUrl: [], linkUrl: ""},{imgUrl: [], linkUrl: ""}],
      };
      this.visible = false;
    }

  
    confirm() {
      this.formRef?.validate().then(() => {
        const params = cloneDeep(this.form);
        
        params.activityTipsImgList = params.activityTipsImgList?.map((el) => {
          return { ...el, imgUrl: el.imgUrl[0].url }
        })
        params.applicationProgramList = params.applicationProgramList?.map((el) => {
          return { applicationProgram: el }
        })
        params.startTime = dayjs(params.startTime).format("YYYY-MM-DD 00:00:00");
        params.endTime = params.endTime ? dayjs(params.endTime).format("YYYY-MM-DD 23:59:59") : undefined;
        console.log("params", params)
        saveOrUpdateClientActivity(params).then((res) => {
          this.$message.success("操作成功");
          this.refreshTable();
          this.cancel();
        })
      });
    }
  
    @Emit("refreshTable")
    refreshTable() {
    }
  
    @Watch("visible")
    setForm(flag) {
      if (!flag) return;
      this.$nextTick(() => {
        if (this.operateRecord?.id) {
          Object.assign(this.form, cloneDeep(this.operateRecord))
        }
      })
    }
  }
  